<script>
  export default {
    props: {
      title: {
        type: String,
        default: '',
      },
      titleClass: {
        type: String,
        default: 'primary-color',
        required: false,
      },
    },
  };
</script>
<template>
  <v-row no-gutters class="items-center" id="">
    <slot name="title">
      <div class="title-class" :class="titleClass">
        {{ title }}
      </div>
    </slot>
    <div class="app_divider"></div>
  </v-row>
</template>
<style lang="scss">
  .title-class {
    font-weight: 500;
    font-size: 1rem;
  }
  .app_divider {
    margin-right: 0.75rem;
    flex: 1;
    height: 1px;
    width: 100%;
    background-color: var(--v-darkColor-base);
  }
</style>
